/*
 * Implemented by widget strategies of capsules that can appear in a My Portfolio Capsule widget
 */
import {
    WidgetStrategy,
    WidgetStrategyWithConfig,
} from 'widgets/WidgetRegistry';
import { WidgetType } from 'widgets/WidgetType';
import { StreamMessage } from 'utils/messages/StreamMessage';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';

export interface MyPortfolioCapsuleContentProps {
    symbol: string;
    symbology: SymbologyValues;
    qty: number;
    qtyRemaining: number;
}

export interface MyPortfolioCapsuleWidgetStrategy extends WidgetStrategy {
    supportsMyPortfolioCapsule: true;
    myPortfolioCapsuleContentReactComponentType: React.FC<MyPortfolioCapsuleContentProps>;
    myPortfolioCapsuleTitleReactComponentType?: React.FC<MyPortfolioCapsuleContentProps>;
    useMessagesInMyPortfolioCapsules: (
        symbol: string,
        symbology: SymbologyValues,
        qty?: number
    ) => StreamMessage[];
    wideTitle?: boolean;
}

export function isMyPortfolioCapsuleWidgetStrategy(
    ws: WidgetStrategy
): ws is MyPortfolioCapsuleWidgetStrategy {
    return (ws as MyPortfolioCapsuleWidgetStrategy).supportsMyPortfolioCapsule;
}

export type WidgetTypeMyPortfolioCapsuleStrategy = {
    type: WidgetType;
    strategy: MyPortfolioCapsuleWidgetStrategy;
};

export interface MyPortfolioCapsuleWidgetStrategyWithConfig<TConfig>
    extends MyPortfolioCapsuleWidgetStrategy,
        WidgetStrategyWithConfig<TConfig> {
    supportsMyPortfolioCapsuleConfig: true;
    renderSettingsBody: (
        config: TConfig,
        onChange: (configDelta: Partial<TConfig>) => void
    ) => JSX.Element;
}

export function isMyPortfolioCapsuleWidgetStrategyWithConfig<TConfig>(
    ws?: WidgetStrategy
): ws is MyPortfolioCapsuleWidgetStrategyWithConfig<TConfig> {
    return !!(
        ws &&
        (ws as MyPortfolioCapsuleWidgetStrategyWithConfig<TConfig>)
            .supportsMyPortfolioCapsuleConfig
    );
}

export type WidgetTypeMyPortfolioCapsuleStrategyWithConfig<TConfig> = {
    type: WidgetType;
    strategy: MyPortfolioCapsuleWidgetStrategyWithConfig<TConfig>;
};
